import { useCallback, useEffect, useMemo, useState } from "react";
import React from "react";
import {
  getPackageListWithFilter,
  getParts,
  getSectionList,
} from "../../../Action/courseAction";
import { useDispatch } from "react-redux";
import Dropdown from "../../../Component/dropdown";
import {
  getMainCategory,
  getSubjectList,
} from "../../../Action/adminPanelAction";
import SquareCheckBox from "../../../Component/SquareCheckBox";

function SubmitExamsetPopup(props) {
  console.count("SubmitExamsetPopup render");
  const dispatch = useDispatch();
  const {
    isOpen,
    exam,
    examStream,
    setIsOpen,
    saveExamset,
    activeTemplate,
    subExam,
    requireMockPart = false,
  } = props;
  const [packageType, setPackageType] = useState("");
  const [mainCategory, setMainCategory] = useState("");
  const [packageTypeList, setPackageTypeList] = useState([]);
  const [mainCategoryList, setMainCategoryList] = useState([]);
  const [packageList, setPackageList] = useState([]);
  const [batch, setBatch] = useState("");

  const partTypeList = useMemo(() => [
    { _id: 0, name: "0" },
    { _id: 1, name: "1" },
    { _id: 2, name: "2" },
    { _id: 3, name: "3" },
    { _id: 4, name: "4" },
    { _id: 5, name: "5" },
  ], []);
  const [partType, setPartType] = useState("");
  const [partList, setPartList] = useState([]);
  const [selectedPart, setSelectedPart] = useState("");
  const [subject, setSubject] = useState("");
  const [subjectList, setSubjectList] = useState([]);
  useEffect(() => {
    dispatch(
      getSectionList(
        "",
        (res) => {
          setPackageTypeList(res?.data);
        },
        () => {},
      ),
    );
    if (exam && examStream) {
      dispatch(
        getSubjectList(
          {
            baseCourseId: examStream?._id,
            examTypeId: exam?._id,
            ...(subExam ? { subExamTypeId: subExam?._id } : {}),
          },
          (res) => {
            setSubjectList(res?.data);
          },
        ),
      );
    }
  }, []);

  const handleApply = () => {
    let tempBatch = packageList
      ?.filter((item) => item?.isSelected)
      .map((item) => item?._id);
    saveExamset(tempBatch, subject?._id, partType?._id, selectedPart?._id);
    setIsOpen(false);
  };

  const isEmpty = (val) => {
    if (Array.isArray(val)) return val.length === 0;
    if (typeof val === "object") return !val || Object.keys(val).length === 0;
    if (typeof val === "string") return val.trim() === "";
    return !val;
  };

  const handleValidate = () => {
    return (
      isEmpty(exam) ||
      isEmpty(examStream) ||
      isEmpty(activeTemplate) ||
      validateArray()
    );
  };

  const validateArray = () => {
    let isValidate = false;
    let tempBatchCount = packageList?.filter((item) => item?.isSelected);
    if (
      (activeTemplate?.id === 1 ||
        activeTemplate?.id === 10 ||
        activeTemplate?.id === 11) &&
      (isEmpty(packageType) ||
        isEmpty(mainCategory) ||
        tempBatchCount?.length === 0)
    ) {
      isValidate = true;
    }
    if (
      activeTemplate?.id === 7 &&
      (isEmpty(packageType) ||
        isEmpty(mainCategory) ||
        tempBatchCount?.length === 0 ||
        isEmpty(partType) ||
        isEmpty(selectedPart))
    ) {
      isValidate = true;
    }
    if (
      // Mock Test (1) needs a part only for callers that save it
      // (QuestionExtractor passes requireMockPart); AICommand ignores it.
      ((activeTemplate?.id === 1 && requireMockPart) ||
        activeTemplate?.id === 3 ||
        activeTemplate?.id === 4 ||
        activeTemplate?.id === 8 ||
        activeTemplate?.id === 5 ||
        activeTemplate?.id === 6 ||
        activeTemplate?.id === 13) &&
      (isEmpty(partType) || isEmpty(selectedPart))
    ) {
      isValidate = true;
    }
    return isValidate;
  };

  const handleReset = () => {
    setPackageType("");
    setMainCategory("");
    setMainCategoryList([]);
    // setBatch("");
    setPackageList([]);
    setPartType("");
    setPartList([]);
    setSelectedPart("");
  };

const onChangePackageType = useCallback((data) => {
    setMainCategory("");
    setMainCategoryList([]);
    setPackageList([]);
    // setBatch("");
    if (data) {
      setPackageType(data);
      const dataCategory = {
        baseCourseId: examStream?._id,
        examTypeId: exam?._id,
      };
      if (subExam) {
        dataCategory.subExamTypeId = subExam?._id;
      }
      dispatch(
        getMainCategory(dataCategory, (res) => {
          let filteredList = res?.data?.filter((item) =>
            data?.type === 6
              ? item?.name?.includes("CRASH")
              : item?.primarySubCatType === data?.type,
          );
          setMainCategoryList(filteredList);
        }),
      );
    } else {
      setPackageType("");
    }
  },[exam, examStream, subExam]);

  const onChangeMaincategory = useCallback((value) => {
    setMainCategory(value);
    setPackageList([]);
    // setBatch("");
    if (value) {
      const data = {
        skip: 0,
        limit: 200,
        sectionType: packageType?.type,
        baseCourseId: examStream?._id,
        examTypeId: exam?._id,
        mainCategoryId: value._id,
      };
      if (subExam) {
        data.subExamTypeId = subExam?._id;
      }

      dispatch(
        getPackageListWithFilter(
          data,
          (res) => {
            setPackageList(res?.data);
          },
          () => {},
        ),
      );
    }
 },[exam, examStream, subExam]);

  const onSelectBatch = useCallback((event, index) => {
    const isChecked = event.target.checked;
    let newArray = [];
    newArray = packageList.map((examItem, i) => {
      if (i === index) {
        return {
          ...examItem,
          isSelected: isChecked,
        };
      }
      return examItem;
    });
    setPackageList(newArray);
  }, [packageList]);

  const onChangePartType = useCallback((value) => {
    setPartType(value);
    if (value) {
      dispatch(
        getParts(value?._id, (res) => {
          if (res?.length > 0) {
            setPartList(res);
          } else {
            setPartList([]);
          }
        }),
      );
    }
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=Syne:wght@600;700&display=swap');

        /* ── Overlay ── */
        .sep__overlay {
          position: fixed;
          inset: 0;
          background: rgba(10, 15, 40, 0.45);
          backdrop-filter: blur(3px);
          z-index: 1055;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: sep__fadeIn 0.2s ease;
        }
        @keyframes sep__fadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }

        /* ── Modal ── */
        .sep__modal {
          background: #fff;
          border-radius: 18px;
          width: 480px;
          max-width: calc(100vw - 32px);
          box-shadow: 0 24px 60px rgba(10,15,40,0.22), 0 2px 8px rgba(10,15,40,0.08);
          animation: sep__slideUp 0.25s cubic-bezier(.22,.68,0,1.2);
          overflow: visible;
          font-family: 'DM Sans', sans-serif;
          overflow: hidden;   /* already set — keep this */
          max-width: calc(100vw - 32px);
        }
        @keyframes sep__slideUp {
          from { opacity: 0; transform: translateY(24px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }

        /* ── Header ── */
        .sep__header {
          background: linear-gradient(135deg, #1a56db 0%, #0e3fa6 100%);
          padding: 22px 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 18px 18px 0 0;
        }
        .sep__header-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .sep__header-icon {
          width: 38px;
          height: 38px;
          background: rgba(255,255,255,0.18);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .sep__title {
          font-family: 'Syne', sans-serif;
          font-size: 17px;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.01em;
          margin: 0;
          line-height: 1.3;
        }
        .sep__subtitle {
          font-size: 12px;
          color: rgba(255,255,255,0.7);
          margin: 2px 0 0;
          line-height: 1.2;
        }
        .sep__close-btn {
          width: 34px;
          height: 34px;
          background: rgba(255,255,255,0.15);
          border: none;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.15s;
          color: #fff;
          padding: 0;
          flex-shrink: 0;
          line-height: 1;
        }
        .sep__close-btn:hover {
          background: rgba(255,255,255,0.28);
        }

        /* ── Body ── */
        .sep__body {
          padding: 15px 24px;
        }

        .sep__field-group {
          margin-bottom: 15px;
        }
        .sep__field-group:last-child {
          margin-bottom: 0;
        }

        .sep__label {
          font-size: 12px;
          font-weight: 600;
          color: #6b7280;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .sep__required {
          color: #ef4444;
        }

        /* ── Custom Select ── */
        .sep__select-wrap {
          position: relative;
        }
        .sep__select-trigger {
          width: 100%;
          background: #f8f9fc;
          border: 1.5px solid #e5e7eb;
          border-radius: 10px;
          padding: 12px 16px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #111827;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
          user-select: none;
          box-sizing: border-box;
        }
        .sep__select-trigger.sep__placeholder {
          color: #9ca3af;
        }
        .sep__select-trigger:hover {
          border-color: #1a56db;
          background: #fff;
        }
        .sep__select-trigger.sep__active {
          border-color: #1a56db;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(26,86,219,0.1);
        }

        .sep__chevron {
          transition: transform 0.2s;
          color: #9ca3af;
          flex-shrink: 0;
        }
        .sep__chevron.sep__rotated {
          transform: rotate(180deg);
          color: #1a56db;
        }

        /* ── Dropdown ── */
        .sep__dropdown {
          position: absolute;
          top: calc(100% + 6px);
          left: 0;
          right: 0;
          background: #fff;
          border: 1.5px solid #e5e7eb;
          border-radius: 10px;
          box-shadow: 0 8px 28px rgba(10,15,40,0.12);
          z-index: 1060;
          overflow: hidden;
          animation: sep__dropDown 0.15s ease;
        }
        @keyframes sep__dropDown {
          from { opacity: 0; transform: translateY(-6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .sep__dropdown-item {
          padding: 11px 16px;
          font-size: 14px;
          font-weight: 400;
          color: #374151;
          cursor: pointer;
          transition: background 0.12s, color 0.12s;
          display: flex;
          align-items: center;
          gap: 10px;
          font-family: 'DM Sans', sans-serif;
        }
        .sep__dropdown-item:hover {
          background: #eff4ff;
          color: #1a56db;
        }
        .sep__dropdown-item.sep__selected {
          background: #eff4ff;
          color: #1a56db;
          font-weight: 600;
        }
        .sep__check {
          width: 18px;
          height: 18px;
          background: #1a56db;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        /* ── Divider ── */
        .sep__divider {
          height: 1px;
          background: #f3f4f6;
          margin: 4px 28px;
        }

        /* ── Footer ── */
        .sep__footer {
          padding: 16px 28px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
        }
        .sep__reset-btn {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 500;
          color: #6b7280;
          background: none;
          border: none;
          cursor: pointer;
          padding: 4px 0;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: color 0.15s;
          text-decoration: underline;
          text-underline-offset: 3px;
          text-decoration-color: transparent;
          line-height: 1;
        }
        .sep__reset-btn:hover {
          color: #ef4444;
          text-decoration-color: #ef4444;
        }
        .sep__footer-right {
          display: flex;
          gap: 10px;
        }
        .sep__cancel-btn {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #374151;
          background: #f3f4f6;
          border: none;
          border-radius: 9px;
          padding: 11px 22px;
          cursor: pointer;
          transition: background 0.15s;
          line-height: 1;
        }
        .sep__cancel-btn:hover {
          background: #e5e7eb;
        }
        .sep__apply-btn {
          font-family: 'Syne', sans-serif;
          font-size: 14px;
          font-weight: 700;
          color: #fff;
          background: linear-gradient(135deg, #1a56db 0%, #0e3fa6 100%);
          border: none;
          border-radius: 9px;
          padding: 11px 28px;
          cursor: pointer;
          box-shadow: 0 3px 14px rgba(26,86,219,0.3);
          transition: opacity 0.15s, transform 0.15s;
          letter-spacing: 0.02em;
          line-height: 1;
        }
        .sep__apply-btn:hover {
          opacity: 0.9;
          transform: translateY(-1px);
        }
        .sep__apply-btn:disabled {
          opacity: 0.45;
          cursor: not-allowed;
          transform: none;
        }
      `}</style>

      {isOpen && (
        <div
          className="sep__overlay"
          onClick={(e) => e.target === e.currentTarget && setIsOpen(false)}
        >
          <div className="sep__modal">
            {/* Header */}
            <div className="sep__header">
              <div className="sep__header-left">
                <div className="sep__header-icon">
                  <svg
                    width="18"
                    height="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#fff"
                    strokeWidth={2.2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 4h18M7 12h10M10 20h4"
                    />
                  </svg>
                </div>
                <div>
                  <div className="sep__title">Select Course</div>
                  {/* <div className="sep__subtitle">Narrow down your results</div> */}
                </div>
              </div>
              <button
                className="sep__close-btn"
                onClick={() => setIsOpen(false)}
              >
                <svg
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="sep__body">
              {/* Package Type */}
              {[1, 7, 10, 11,12].includes(activeTemplate?.id) && (
                <div className="sep__field-group">
                  <div className="sep__label">
                    <svg
                      width="13"
                      height="13"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10"
                      />
                    </svg>
                    Package Type <span className="sep__required">*</span>
                  </div>
                  <div className="sep__select-wrap">
                    <Dropdown
                      labelName="Select Package Type"
                      setInputText={(value) => onChangePackageType(value)}
                      value={packageType}
                      options={packageTypeList}
                    />
                  </div>
                </div>
              )}

              {/* Main Category */}

              {[1, 7, 10, 11,12].includes(activeTemplate?.id) && (
                <div className="sep__field-group">
                  <div className="sep__label">
                    <svg
                      width="13"
                      height="13"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 10h16M4 14h8"
                      />
                    </svg>
                    Main Category <span className="sep__required">*</span>
                  </div>
                  <div className="sep__select-wrap">
                    <Dropdown
                      labelName="Main Category"
                      setInputText={(value) => onChangeMaincategory(value)}
                      value={mainCategory}
                      options={mainCategoryList}
                    />
                  </div>
                </div>
              )}

              {/* Batch */}
              {[1, 7, 10, 11,12].includes(activeTemplate?.id) && (
                <div className="sep__field-group">
                  <div className="sep__label">
                    <svg
                      width="13"
                      height="13"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 10h16M4 14h8"
                      />
                    </svg>
                    Batch <span className="sep__required">*</span>
                  </div>
                  {packageList?.length > 0 && (
                    <div
                      className="sep__select-wrap"
                      style={{ width: "100%", minWidth: 0 }}
                    >
                      {/* <Dropdown
                    labelName="Select Batch"
                    setInputText={(value) => setBatch(value)}
                    value={batch}
                    options={packageList}
                  /> */}
                      <div className="d-flex align-items-start">
                        <div
                          className="border border-1 rounded-2 w-100 overflow-auto"
                          style={{ maxHeight: "150px" }}
                        >
                          {packageList.map((c, index) => (
                            <div
                              className="d-flex font-12 align-items-center border-bottom py-1 px-2 mb-1"
                              key={c._id}
                            >
                              <SquareCheckBox
                                id={c._id}
                                type="checkbox"
                                name="Subject Name"
                                value={c.name}
                                checked={c.isSelected}
                                onChange={(e) => onSelectBatch(e, index)}
                              />

                              <div className="d-flex justify-content-between align-items-center cursor w-100">
                                <div>{c.name}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/*Subject */}
              {props?.subjectHide
                ? ![1, 2, 10, 11 ,12].includes(activeTemplate?.id) && (
                    <div className="sep__field-group">
                      <div className="sep__label">
                        <svg
                          width="13"
                          height="13"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M4 6h16M4 10h16M4 14h8"
                          />
                        </svg>
                        Subject Name <span className="sep__required">*</span>
                      </div>
                      <div
                        className="sep__select-wrap"
                        style={{ width: "100%", minWidth: 0 }}
                      >
                        <Dropdown
                          labelName="Select Subject Name"
                          setInputText={(value) => setSubject(value)}
                          value={subject}
                          options={subjectList}
                        />
                      </div>
                    </div>
                  )
                : null}
              {![ 2, 10, 11,12].includes(activeTemplate?.id) && (
                <div className="sep__field-group">
                  <div className="sep__label">
                    <svg
                      width="13"
                      height="13"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 10h16M4 14h8"
                      />
                    </svg>
                    Part Type <span className="sep__required">*</span>
                  </div>
                  <div
                    className="sep__select-wrap"
                    style={{ width: "100%", minWidth: 0 }}
                  >
                    <Dropdown
                      labelName="Select Part Type"
                      setInputText={(value) => onChangePartType(value)}
                      options={partTypeList}
                      value={partType}
                    />
                  </div>
                </div>
              )}

              {![ 2, 10, 11,12].includes(activeTemplate?.id) && (
                <div className="sep__field-group">
                  <div className="sep__label">
                    <svg
                      width="13"
                      height="13"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 10h16M4 14h8"
                      />
                    </svg>
                    Part <span className="sep__required">*</span>
                  </div>
                  <div
                    className="sep__select-wrap"
                    style={{ width: "100%", minWidth: 0 }}
                  >
                    <Dropdown
                      labelName="Select Part"
                      setInputText={(value) => setSelectedPart(value)}
                      options={partList}
                      value={selectedPart}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="sep__divider" />

            {/* Footer */}
            <div className="sep__footer">
              <button className="sep__reset-btn" onClick={handleReset}>
                <svg
                  width="13"
                  height="13"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2.2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                Reset Filters
              </button>
              <div className="sep__footer-right">
                <button
                  className="sep__cancel-btn"
                  onClick={() => setIsOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="sep__apply-btn"
                  onClick={handleApply}
                  disabled={handleValidate()}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default React.memo(SubmitExamsetPopup);